export default "__VITE_ASSET__BroAJGIg__"